/*
 * Tabs script
 */
class ME_Tabs {
    constructor() {
        this.initState();
    }

    initState() {
        this.currentIndex = 0;
        this.win = jQuery(window);
        this.wrapper = $('.js-tabs');
        this.tabs = this.wrapper.find('.js-tablinks-wrapper .js-tablinks');
        this.contents = this.wrapper.find('.js-tabcontent-wrapper .js-tabcontent');
        this.animationInProgress = false;

        if (this.tabs.length) {
            this.initTabsEvents();
        }
    }

    initTabsEvents() {
        for (let i = 0; i < this.tabs.length; i++) {
            this.tabs.eq(i).on('click', () => {
                this.tabs.removeClass('active');
                this.tabs.eq(i).addClass('active');
                this.contents.removeClass('active');
                this.contents.eq(i).addClass('active');
                this.animationInProgress = true;
            });
        }
    }
}
